import "./slider_type1/slider_type1.js";
import "./image_box_slider/image_box_slider.js";
